import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const SustainabilityStrategyAndCarbonFootprint = () => {
  const serviceData = {
    title: "Sustainability Strategy & Carbon Footprint",
    heading: "Sustainability Strategy & Carbon Footprint",
    image:
      subTopicImages["Sustainability Strategy & Carbon Footprint Analysis"],
    intro: "",
    description: [
      "We help organisations understand their environmental impact and build a long-term sustainability roadmap.",
    ],
    services: [
      {
        title: "This Includes",
        list: [
          "carbon footprint assessments (Scope 1, 2 & 3)",
          "ESG maturity and gap assessments",
          "sustainability strategy design",
          "efficiency & climate-impact initiatives",
        ],
        extraInfo:
          "This enables businesses to plan responsibly for climate-aligned growth.",
      },
    ],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default SustainabilityStrategyAndCarbonFootprint;
